class FacetBase extends HTMLElement {
  constructor() {
    super();
    this.controller = null;
  }

  abortRequest() {
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    return this.controller.signal;
  }

   async fetchAndRender(urlObj) {
    const signal = this.abortRequest();
    const queryInput = document.querySelector('[name="q"]');
    if (queryInput && queryInput.value.trim().length > 0) {
      urlObj.searchParams.set("q", queryInput.value.trim());
      urlObj.searchParams.set("type", "product");
    }
    urlObj.searchParams.set("section_id", this.sectionId);

    fetch(urlObj.toString(), { signal })
    .then(async (res) => {
      const data = await res.text();
      urlObj.searchParams.delete("section_id");
      window.history.replaceState({}, "", urlObj.toString());
      const html = new DOMParser().parseFromString(data, "text/html");

      await this.replaceContent(
        ["collection-grid", "active-filter", "active-sorting"],
        this.sectionId,
        html
      );

      this.updateFilterItems(html);
    })
    .catch((error) => {
      if (error.name !== "AbortError") {
        console.error("Request failed:", error);
      }
    });
  }

  replaceContent(selectors, sectionId, html) {
    selectors.forEach((selector) => {
      const targetSelector = `[data-${selector}-${sectionId}]`;
      const target = document.querySelector(targetSelector);
      const source = html.querySelector(targetSelector);
      if (target && source) {
        target.innerHTML = source.innerHTML;
      }
    });
    initializePagination();
    if(document.querySelector('.collection_filter').classList.contains('active')){ 
        document.querySelector('.collection_filter').classList.remove('active');
    }
    console.log(document.querySelector('.collection_filter').classList.contains('active'));
  }
  
  updateFilterItems(html) {
    const newFilterItems = html.querySelectorAll(".facets__label");
    const currentFilterItems = document.querySelectorAll(".facets__label");

    currentFilterItems.forEach((item, i) => {
      const newItem = newFilterItems[i];
      if (newItem) item.innerHTML = newItem.innerHTML;
    });
  }

  disconnectedCallback() {
    if (this.controller) this.controller.abort();
  }
}

class FacetFiltersForm extends FacetBase {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sectionId = this.dataset.section;
    const facetForm = this.querySelector("form");
    if (facetForm) {
      facetForm.addEventListener("input", (event) => this.onSubmitHandler(event));
      facetForm.addEventListener("change", (event) => this.onSubmitHandler(event));
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const params = new URLSearchParams();

    this.querySelectorAll("input:checked").forEach((input) => {
      params.append(input.name, input.value);
    });
     
    const sortOption = document.querySelector("sort-option")?.getSelectedValue();
    if (sortOption) params.append("sort_by", sortOption);
    
    const urlObj = new URL(window.location.pathname, window.location.origin);
    urlObj.search = params.toString();

    this.fetchAndRender(urlObj);
  }
}

customElements.define("facet-filters-form", FacetFiltersForm);

class FacetRemove extends FacetBase {
  connectedCallback() {
    this.facetLink = this.querySelector("a");
    this.url = this.facetLink?.href;
    this.sectionId = this.closest(".active-facets, .remove-active-facets")?.dataset.sectionId;

    if (this.facetLink) {
      this.facetLink.addEventListener("click", this.removeFilter.bind(this));
    }
  }

  removeFilter(event) {
    event.preventDefault();

    const urlObj = new URL(this.url, window.location.origin);
    this.fetchAndRender(urlObj);
  }
}

customElements.define("facet-remove", FacetRemove);

class SortOption extends FacetBase {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.sortSelect = document.querySelector("#SortBy"); 

    if (this.sortSelect) {
      this.sortSelect.addEventListener("change", (event) => this.onSubmitHandler(event));
    }
  }

  getSelectedValue() {
    return this.sortSelect?.value || null;
  }

  onSubmitHandler(event) {
    const selectedValue = event.target.value;
    const params = new URLSearchParams(window.location.search);

    if (selectedValue) {
      params.set("sort_by", selectedValue);
    } else {
      params.delete("sort_by");
    }

    const urlObj = new URL(window.location.pathname, window.location.origin);
    urlObj.search = params.toString();
    
    Array.from(this.sortSelect.options).forEach(option => {
      option.removeAttribute("selected");
      if (option.value === selectedValue) option.setAttribute("selected", "");
    });

    // Trigger re-render
    this.fetchAndRender(urlObj);
  }
}

customElements.define("sort-option", SortOption);

function initializePagination(){
  const pagination_type = document.querySelector('.main-collection-section .collection-pagination')?.getAttribute('pagination-type');
  let loader = document.querySelector(".loader");
  //console.log(loader);
    if(pagination_type == 'endless_scroll'){
      var endlessScroll = new Ajaxinate({
            container: '#AjaxinateContainer',
            pagination: '#AjaxinatePagination',
            method: 'scroll',
            offset: 300,
            loadingText: '', 
            callback: (e) => {
              console.log(e);
              console.log(loader);
              // if (loader) loader.style.display = "none";
            }
          });

      const originalLoadMore = endlessScroll.loadMore.bind(endlessScroll);
      endlessScroll.loadMore = function() {
        if (loader) loader.style.display = "flex";
        originalLoadMore();
      };
    }
}

document.addEventListener('DOMContentLoaded', function () {
  initializePagination();
});

